export type ExternalLinkType = "google-drive" | "dropbox" | "external";

export interface ExternalLinkInfo {
  label: string;
  type: ExternalLinkType;
  /** Path to brand icon in /public, or null for generic external links */
  iconUrl: string | null;
}

export function getExternalLinkLabel(url: string): ExternalLinkInfo {
  try {
    const hostname = new URL(url).hostname;
    if (hostname.includes("drive.google.com") || hostname.includes("docs.google.com")) {
      return { label: "Google Drive", type: "google-drive", iconUrl: "/google-drive-icon.png" };
    }
    if (hostname.includes("dropbox.com")) {
      return { label: "Dropbox", type: "dropbox", iconUrl: "/dropbox-icon.png" };
    }
    return { label: "External", type: "external", iconUrl: null };
  } catch {
    return { label: "External", type: "external", iconUrl: null };
  }
}
